<div class="chart-container">
  <svg id="spot-ladder"></svg>
</div>
